"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isIWebinarEntity = exports.isISurveyEntity = exports.isIScormEntity = exports.isILessonEntity = exports.isIQuizEntity = void 0;
var tslib_1 = require("tslib");
var entityService_1 = require("../../entityService");
tslib_1.__exportStar(require("./ILesson"), exports);
tslib_1.__exportStar(require("./Quiz"), exports);
tslib_1.__exportStar(require("./IScorm"), exports);
tslib_1.__exportStar(require("./Survey"), exports);
var isIQuizEntity = function (entity) {
    return entity.__type === entityService_1.corePaths.quiz;
};
exports.isIQuizEntity = isIQuizEntity;
var isILessonEntity = function (entity) {
    return entity.__type === entityService_1.corePaths.lesson;
};
exports.isILessonEntity = isILessonEntity;
var isIScormEntity = function (entity) {
    return entity.__type === entityService_1.corePaths.scorm;
};
exports.isIScormEntity = isIScormEntity;
var isISurveyEntity = function (entity) {
    return entity.__type === entityService_1.corePaths.survey;
};
exports.isISurveyEntity = isISurveyEntity;
var isIWebinarEntity = function (entity) {
    return entity.__type === entityService_1.corePaths.webinar;
};
exports.isIWebinarEntity = isIWebinarEntity;
